import type { ReactElement } from 'react'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/popover/Popover'

interface SyncManagedByPopoverProps {
  children: ReactElement
  connectorLabel: string | null
  action: 'disconnect' | 'reconnect'
}

export function SyncManagedByPopover({ children, connectorLabel, action }: SyncManagedByPopoverProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent
        width="auto"
        align="end"
        side="bottom"
        sideOffset={4}
        collisionPadding={16}
        showArrow={false}
        className="w-[304px] max-w-[calc(100vw-2rem)] border border-brand-neutral-200 p-4 shadow-[0_0_15px_-3px_rgba(0,0,0,0.1),0_0_6px_-2px_rgba(0,0,0,0.05)]"
      >
        <div className="flex flex-col items-start gap-1">
          <p className="text-sm font-medium leading-5 tracking-[-0.15px] text-brand-neutral-600">
            This sync is managed by {connectorLabel ?? 'another matter member'}. Only they can modify or {action} it.
          </p>
        </div>
      </PopoverContent>
    </Popover>
  )
}
